import clsx from "clsx"
import {
  type ReactElement,
  type ReactNode,
  isValidElement,
  useState,
} from "react"
import { NetworkIcon } from "./DefuseSDK/components/Network/NetworkIcon"
import type { ChainIcon } from "./DefuseSDK/constants/blockchains"
import TokenIconPlaceholder from "./TokenIconPlaceholder"

const WalletButton = ({
  name,
  icon,
  badge,
  onClick,
  dataTestId,
  disabled = false,
}: {
  name: string
  icon?: string | ChainIcon | ChainIcon[] | ReactElement
  badge?: ReactNode
  onClick: () => void
  dataTestId?: string
  disabled?: boolean
}) => {
  const [erroredSrc, setErroredSrc] = useState<string | null>(null)
  const showPlaceholder =
    !icon || (typeof icon === "string" && erroredSrc === icon)

  return (
    <button
      type="button"
      data-testid={dataTestId}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        "-outline-offset-1 hover:not-disabled:-outline-offset-2 focus-visible:-outline-offset-2 flex flex-col items-start gap-5 overflow-hidden rounded-2xl bg-white p-4 text-left outline outline-gray-200 hover:not-disabled:outline-2 hover:not-disabled:outline-gray-400 focus-visible:outline-2 focus-visible:outline-gray-400 min-[350px]:p-5 dark:bg-gray-800 dark:outline-white/5",
        disabled && "cursor-not-allowed opacity-60"
      )}
    >
      <span className="flex w-full items-start justify-between gap-2">
        {showPlaceholder ? (
          <TokenIconPlaceholder className="size-10" />
        ) : typeof icon === "string" ? (
          <img
            src={icon}
            alt=""
            referrerPolicy="no-referrer"
            onError={() => setErroredSrc(icon)}
            className="-outline-offset-1 relative flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-100 object-contain outline-1 outline-gray-900/10 dark:bg-gray-700 dark:outline-white/10"
          />
        ) : Array.isArray(icon) ? (
          <div className="-space-x-6 min-[350px]:-space-x-4 flex shrink-0 items-center">
            {icon.map((chainIcon, index, icons) => (
              <div
                key={chainIcon.light}
                style={{ zIndex: icons.length - index }}
                className="last:hidden sm:last:block"
              >
                <NetworkIcon
                  chainIcon={chainIcon}
                  className="ring-2 ring-white dark:ring-gray-800"
                  sizeClassName="size-10"
                />
              </div>
            ))}
          </div>
        ) : isValidElement(icon) ? (
          icon
        ) : (
          <NetworkIcon chainIcon={icon} sizeClassName="size-10" />
        )}
        {badge && badge}
      </span>
      <span className="w-full truncate font-semibold text-gray-900 text-sm/4 min-[350px]:text-base/5 dark:text-white">
        {name}
      </span>
    </button>
  )
}

export default WalletButton
